import { db } from "@/firebase"
import firebase from "firebase"
const installations_ref = db.collection("installations")
import ProjectsService from "@/services/server/ProjectsService.js";
import store from '@/store/index'

const subCollection = "items"

const objectItemInstallation = (item) => {
    return {
        ...item,
        id_doc: item.id_doc || null,
        local: item.local || null,
        sub_local: item.sub_local || null,
        type: item.type || null,
        solution: item.solution || null,
        amountSolution: item.amountSolution || null,
        flowRateBefore: item.flowRateBefore || null,
        flowRateAfter: item.flowRateAfter || null,
        economy: item.economy || null,
        date: item.date || null,
        status: item.status || null,
        comments: item.comments || null,
        file_after: item.file_after || null,
        file_before: item.file_before || null,
        file_extra: item.file_extra || null,
        updatedAt: new Date(),
        updatedBy: store.state.currentUser?.uid
    }
}
const createInstallationDoc = async (idProject) => {
    try {
        console.log("Criando nova instalação...")
        const newDocRef = await installations_ref.add({
            id_project: idProject,
            createdAt: new Date().getTime(),
            lastUpdateAt: new Date().getTime(),
        });
        const installationDocId = newDocRef.id;
        await ProjectsService.updateProject(idProject, { id_installation: installationDocId });
        return installationDocId;
    } catch (error) {
        throw new Error("createInstallationDoc Fail! " + error);
    }
}
const updateInstallationWithDeleteConsumptionHistoric = async (idInstallation) => {
    try {
        await installations_ref.doc(idInstallation).update({
            lastUpdateAt: new Date().getTime(),
            consumptionHistoric: firebase.firestore.FieldValue.delete()
        });
        return idInstallation;
    } catch (error) {
        throw new Error("updateInstallationWithDeleteConsumptionHistoric Fail! " + error);
    }
}
const createInstallationSubCollection = async (installationData, idInstallation) => {
    try {
        if (!Array.isArray(installationData) || installationData.length === 0) console.log("Não há soluções para salvar")

        for (const item of installationData) {
            const cleanItem = objectItemInstallation(item);
            const itemId = cleanItem.id_doc
            if (itemId) {
                delete cleanItem.isModified
                await installations_ref.doc(idInstallation)
                    .collection(subCollection)
                    .doc(itemId)
                    .set(cleanItem, { merge: true });
            } else {
                delete cleanItem.isModified
                const newItemRef = await installations_ref.doc(idInstallation)
                    .collection(subCollection)
                    .add({
                        ...cleanItem,
                        createdAt: new Date(),
                        createdBy: store.state.currentUser?.uid,
                        isDeleted: false
                    });
                await newItemRef.update({ id_doc: newItemRef.id });
            }
        }
        return installationData
    } catch (error) {
        throw new Error("createInstallation Fail! " + error);
    }
}
const editInstallationProposal = async (idDoc, data) => {
    try {
        await installations_ref.doc(idDoc).update(data);
        return true;
    } catch (error) {
        throw new Error("editInstallationProposal Fail!" + error)
    }
}
async function getInstallationProposal() {
    let leads_list = []
    try {
        const unitsRef = await installations_ref.get()
        unitsRef.forEach((doc) => leads_list.push(doc.data()));
        return leads_list
    } catch (error) {
        console.error(error)
    }
}

async function getInstallationProposalById(id) {
    try {
        const result = await installations_ref.doc(id).get()
        return result.data()
    } catch (error) {
        throw new Error('Failed to get installations by project ID: ' + error);
    }
}

async function getInstallationById(id) {
    try {
        const result = await installations_ref.doc(id).get()

        const itemsSnapshot = await result.ref
            .collection(subCollection)
            .where('isDeleted', '==', false).get();
        let items = [];
        itemsSnapshot.forEach(doc => {
            items.push({ id: doc.id, ...doc.data() });
        });

        return { installation: result.data(), items }
    } catch (error) {
        throw new Error('Failed to get installation by id: ' + error);
    }
}

async function getLastProposalByDiagnosticId(idDiagnostic) {
    let leads_list = []
    try {
        const result = await installations_ref.where('id_diagnostic', "==", idDiagnostic)
            .orderBy('createdAt', "desc")
            .limit(1)
            .get()
        result.forEach((doc) => leads_list.push(doc.data()));
        return leads_list
    } catch (error) {
        console.error(error)
    }
}

async function getInstallationByProjectlId(idProject) {
    try {
        const querySnapshot = await installations_ref.where('id_project', '==', idProject).limit(1).get();
        if (querySnapshot.empty) {
            return [];
        }
        const installationDoc = querySnapshot.docs[0];
        const itemsSnapshot = await installationDoc.ref.collection(subCollection)
            .where('isDeleted', '==', false).get();
        const items = [];
        itemsSnapshot.forEach(doc => {
            items.push({ id: doc.id, ...doc.data() });
        });
        return items;
    } catch (error) {
        console.error("Error getting items from subcollection by idProject:", error);
        return [];
    }
}

async function deleteInstallation(installationId, itemId) {
    try {
        if (!installationId) {
            throw new Error('Installation not found for that projectId');
        }
        await installations_ref
            .doc(installationId)
            .collection(subCollection)
            .doc(itemId)
            .update({
                isDeleted: true,
                deletedAt: new Date(),
                deletedBy: store.state.currentUser?.uid
            })
        return true;
    } catch (error) {
        throw new Error('deleteInstallation Fail! ' + error);
    }
}

export default {
    createInstallationDoc,
    createInstallationSubCollection,
    updateInstallationWithDeleteConsumptionHistoric,
    getInstallationProposal,
    editInstallationProposal,
    getLastProposalByDiagnosticId,
    getInstallationProposalById,
    getInstallationById,
    getInstallationByProjectlId,
    deleteInstallation,
};